<template>
  <v-dialog persistent v-model="dialog" width="720px">
    <v-card>
      <v-card-title>
          <span class="headline">
            {{ $t("cloudPrinterSetting.settingBtn") }}
          </span>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>
              {{ $t("CRUD.backToList", [$t("cloudPrinterSetting.title")]) }}
            </span>
        </v-tooltip>
      </v-card-title>

      <v-card-text>
        <v-container>
           <ValidationObserver ref="observer">
          <v-form>
            <v-row>
              <!-- USER -->
              <v-col cols="12">
                <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('cloudPrinterSetting.feie.user')"
                    rules="required"
                >
                    <span class="d-flex">
                        {{ $t('cloudPrinterSetting.feie.user') }}{{ $t("Global.colon") }}
                        <v-text-field
                            v-model="feieUser"
                            single-line
                            dense
                            :error-messages="errors"
                        ><template v-slot:message="{ key, message }">
                            <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                            </div>
                        </template>
                        </v-text-field>
                    </span>
                </ValidationProvider>
                </v-col>
              <!-- UKEY -->
              <v-col cols="12">
                    <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('cloudPrinterSetting.feie.ukey')"
                        rules="required"
                    >
                    <span class="d-flex">
                        {{ $t('cloudPrinterSetting.feie.ukey') }}{{ $t("Global.colon") }}
                        <v-text-field
                            v-model="feieUkey"
                            single-line
                            dense
                            :error-messages="errors"
                        ><template v-slot:message="{ key, message }">
                            <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                            </div>
                        </template>
                        </v-text-field>
                    </span>
                    </ValidationProvider>
                </v-col>
            </v-row>
          </v-form>
           </ValidationObserver>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
            <v-btn color="primary" outlined @click="dialog = false">{{ $t("$vuetify.close") }}</v-btn>
            <v-btn color="accent" @click="submit()">{{ $t("CRUD.confirm") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import CloudPrints from "@/api/cloud_prints";
import { ValidationObserver, ValidationProvider } from "vee-validate";


export default {
    name: "SettingDialog",

    props: {
        value: Boolean,
        user: String,
        ukey: String
    },
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data: () => ({
        dialog: false,
        feieUser: "",
        feieUkey: "",
    }),
    mounted() {

    },
    methods: {
        submit() {
            this.$refs.observer.validate().then(
                async function (result) {
                    if (result) {
                        CloudPrints.saveSetting({user:this.feieUser, ukey:this.feieUkey}).then(
                            function (response) {
                                if (response.data.status.isOK()) {
                                    this.dialog = false
                                    this.$emit("save", this.dialog);
                                }
                            }.bind(this)
                        );
                    }
                }.bind(this));
        },
    },

    watch: {
        value: {
            immediate: false, //初始赋值也调用
            handler() {
                if (this.value){
                    this.feieUser = this.user;
                    this.feieUkey = this.ukey;
                }
                this.dialog = this.value;
            },
        },
        dialog: {
            handler() {
                this.$emit("input", this.dialog);
            },
        }
    },
};
</script>